import React from "react";
import { FaTimes } from "@react-icons/all-files/fa/FaTimes";
import { FaChevronRight } from "@react-icons/all-files/fa/FaChevronRight";
import * as styles from "/src/components/Sidebar.module.css";
import { Link } from "gatsby";
import { v4 as uuidv4 } from "uuid";

const Sidebar = ({ onPress, isVisible }) => {
  const links = [
    { page: "About", to: "/about" },
    { page: "Projects", to: "/projects" },
    { page: "Resources", to: "/resources" },
    { page: "Blog", to: "/blog" },
    { page: "EcoChamps", to: "/ecochamps" },
    { page: "Contact", to: "/contact" },
  ];
  return (
    <div
      className={`${styles.sidebar} ${isVisible ? styles.activeSidebar : ""}`}
    >
      <div className={styles.closeIcon}>
        <FaTimes onClick={onPress} />
      </div>
      <nav className={styles.linksContainer}>
        <div className={styles.linksContainer}>
          {links.map((entry) => (
            <Link onClick={onPress} key={uuidv4()} to={entry.to}>
              {entry.page}
            </Link>
          ))}
          <Link
            className={styles.signupButton}
            onClick={onPress}
            key={uuidv4()}
            to={"/volunteer"}
            style={{ color: "rgb(31, 80, 15)" }}
          >
            <h4>SIGN UP NOW</h4>
            <FaChevronRight size={20} />
          </Link>
        </div>
      </nav>
    </div>
  );
};

export default Sidebar;
